export const SET_USER_CONTEXT = 'SET_USER_CONTEXT'
export const SET_FORMS_DATA = 'SET_FORMS_DATA'
export const SET_NEXT_FORM = 'SET_NEXT_FORM'
